import Vue from "vue";
import {
  acquireScreenWakeLock,
  ReleaseScreenWakeLock,
} from "@/utils/screenWakeLock";

type ScreenWakeLockMixinState = {
  releaseScreenWakeLock: ReleaseScreenWakeLock | null;
  screenWakeLockPromise: Promise<void> | null;
  screenWakeLockReleaseRequested: boolean;
};

export default Vue.extend({
  data(): ScreenWakeLockMixinState {
    return {
      releaseScreenWakeLock: null,
      screenWakeLockPromise: null,
      screenWakeLockReleaseRequested: false,
    };
  },
  methods: {
    acquireScreenWakeLockForCall(): Promise<void> {
      if (this.releaseScreenWakeLock) {
        return Promise.resolve();
      }

      if (this.screenWakeLockPromise) {
        this.screenWakeLockReleaseRequested = false;
        return this.screenWakeLockPromise;
      }

      this.screenWakeLockReleaseRequested = false;
      this.screenWakeLockPromise = acquireScreenWakeLock()
        .then((release) => {
          if (this.screenWakeLockReleaseRequested) {
            release();
            return;
          }

          this.releaseScreenWakeLock = release;
        })
        .finally(() => {
          this.screenWakeLockPromise = null;
        });

      return this.screenWakeLockPromise;
    },
    releaseScreenWakeLockForCall(): void {
      this.screenWakeLockReleaseRequested = true;

      if (this.releaseScreenWakeLock) {
        this.releaseScreenWakeLock();
        this.releaseScreenWakeLock = null;
      }
    },
  },
});
